import 'whatwg-fetch';
import '@/utils/polyfills/event_polyfills';

import { mockI, uri } from '@/utils/imperia_mocks';

// Prevent all sorts of problems by mocking the data in one place
if (process.env.NODE_ENV === 'test') {
  mockI();
}

Object.defineProperty(window, 'I', {
  value: window.I || {},
});

if (!window.I.gt) {
  Object.defineProperty(window.I, 'gt', {
    value: window.I.gt || { __: (str) => str },
  });
}

if (!window.I.Util) {
  Object.defineProperty(window.I, 'Util', {
    value: window.I.Util || { uri },
  });
}

if (!window.I.jQuery) {
  Object.defineProperty(window.I, 'jQuery', {
    value: window.I.jQuery || window.jQuery,
  });
}

if (!window.I.MAM) {
  window.I.MAM = window.I.MAM || window.MAM;
}

// if (window.I.MAM && !window.I.MAM.showActions) {
//   const mockShowActions = () => {};
//   Object.defineProperty(window.I.MAM, 'showActions', {
//     value: window.I.MAM.showActions || mockShowActions,
//   });
// }

const globals = {
  I: window.I,
  context: window,
};

export default globals;
